import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import lightbox from 'lightbox2';

class BlockSliderImages {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-images__swiper', {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      },
    });


    lightbox.option({
      resizeDuration: 200,
      wrapAround: true,
      showImageNumberLabel: false,
      disableScrolling: true
    });
  }
}

export const blockSliderImages = new BlockSliderImages();
